$(document).ready(() => {

    const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();

	let resizeTimeout;

	const resize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setVh();
		}, 150);
	}

	window.addEventListener('resize', resize);
	window.addEventListener('orientationchange', resize);
	window.addEventListener('scroll', resize);


	let lastHeight = window.innerHeight;
	const monitorHeight = () => {
		const currentHeight = window.innerHeight;
		if (currentHeight !== lastHeight) {
			lastHeight = currentHeight;
			setVh();
		}
		requestAnimationFrame(monitorHeight);
	};
	monitorHeight();

    $("[data-match-height]").each(function () {
        $(this)
            .find($(this).attr("data-match-height"))
            .matchHeight();
    });

    $('body').on('click', '#header .menu-popup .toggle:not(.back)', function () {
        $("#menu_popup").toggleClass("open");
        $("body").addClass("disable_scroll");
        $("#header .menu-popup .toggle").addClass("back");
        setTimeout(() => $("#menu_popup").toggleClass("animate"), 10);
    });
    $('body').on(
        'click',
        '#header .menu-popup .back,#menu_popup .back',
        function () {
            $("#menu_popup").removeClass("animate");
            $("body").removeClass("disable_scroll");
            $("#header .menu-popup .toggle").removeClass("back");
            setTimeout(() => $("#menu_popup").removeClass("open"), 400);
        }
    );

		const playWhenVisible = function(item, slider){
			const Obs = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if(!entry.isIntersecting){
						slider.pause();
					}
					else {
						slider.play();
					}
				});
			}, {
				root: null,
				rootMargin: '0px',
				threshold: 0.3
			});
			Obs.observe($(item).closest('.tns-outer')[0]);
		};

		let autoplayTimeout=5000;
		if(!$('body').hasClass('home'))autoplayTimeout = 3000;

		if($('.home-bg .slider >*').length > 1){
			const homeSlider = tns({
				container: ".home-bg .slider",
				items: 1,
				gutter: 0,
				controlsText: [
					"", ""
				],
				nav: true,
				loop: true,
				autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				autoplayTimeout:autoplayTimeout
			});
			playWhenVisible($(".home-bg .slider")[0], homeSlider);
		}

    if ($(".booking .slider").length) {
        const BookinkSlider = tns({
            container: ".booking .slider",
            items: 1,
            gutter: 30,
            controlsText: [
                "", ""
            ],
            nav: false,
            loop: true,
						autoplay: true,
					autoplayButtonOutput:false,
					autoplayHoverPause:true,
						autoplayTimeout:autoplayTimeout
        });
				playWhenVisible($(".booking .slider")[0], BookinkSlider);
    }

    $('.slider-type1 .slider').each(function(){
			const slider = tns({
			 container: this,
			 items: 1,
			 gutter: 30,
			//  controlsText: ["", ""],
			 controls: true,
			 controlsContainer: $(this).closest('.slider-type1').find(">.my-controls")[0],
			 nav: false,
			 loop: true,
				autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				autoplayTimeout:autoplayTimeout
			});
			$('.slider-type1 .slider .btn-wrap .my-controls button').click(function(e){
				e.stopImmediatePropagation();
				if($(this).hasClass('prew'))$(this).closest('.slider-type1').find('>.my-controls button.prew').trigger('click');
				else if($(this).hasClass('next'))$(this).closest('.slider-type1').find('>.my-controls button.next').trigger('click');
			});
			playWhenVisible(this, slider);
	});

    $('.only-img .slider').each(function () {
        const slider = tns({
            container: this,
            items: 1,
            gutter: 30,
            controlsText: [
                "", ""
            ],
            controlsContainer: $(this)
                .parent()
                .find(".my-controls")[0],
            nav: false,
            loop: true,
						autoplay: true,
					autoplayButtonOutput:false,
					autoplayHoverPause:true,
					autoplayTimeout:autoplayTimeout
        });
				playWhenVisible(this, slider);
    });
	
    $(".datepicker").datepicker({autoHide: true, format: "dd/mm/yyyy"});
    $(".datepicker_dd_mm").datepicker({autoHide: true, format: "dd.mm.yy"});

    $(".dropdown .title").click(function (e) {
        const el = $(this).parent();
        if (el.hasClass('active')) {
            el.removeClass('active');
            $(document).off('click.dropdown');
        } else {
            if ($(".dropdown.active").length > 0) {
                $(".dropdown.active .title").trigger('click');
            }
            el.addClass('active');
            setTimeout(() => {
                $(document).one('click.dropdown', function () {
                    el.removeClass('active');
                });
            }, 1);

        }
    });
    $('body').on('click', ".dropdown .content", function (e) {
        e.stopPropagation();
    });
    $(".dropdown .sld button").click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        const input = $(this)
            .parent()
            .find('input');
        let v = input.val() * 1;
        if ($(this).hasClass('up')) {
            v++;
        } else if (v > 0) {
            v--;
        }
        input.val(v);
    });

    $("body").on("click", ".open_popup", function (e) {
        e.preventDefault();
        if ($(this).attr("data-target")) {
            $($(this).attr("data-target")).openPopup();
        }
    });

    $(".dropdown .drop")
        .focus(function () {
            $(this)
                .parent()
                .addClass('active');

        })
        .blur(function () {
            $(this)
                .parent()
                .removeClass('active');
        })

    $("body").on(
        "click",
        ".popup button.close, .popup button.close_btn",
        function (e) {
            e.preventDefault();
            $(this)
                .closest(".popup")
                .closePopup();
        }
    );

  const header = $("#header");
	const headerFixed = ()=> {
		if ($(window).scrollTop() > 10) {
			header.addClass("fixed");
		} else {
			header.removeClass("fixed");
		}
	};
	$(window).scroll(headerFixed);
	headerFixed();
	$('.mobile-menu-open').click(function(){
		$('#header .ls').addClass('open');
		$('body').addClass('disable-scroll');
	})
	$('.mobile-menu-close').click(function(){
		$('#header .ls').removeClass('open');
		$('body').removeClass('disable-scroll');
	})

	Fancybox.bind("[data-fancybox]", {
		Carousel: {
			formatCaption: (_carouselRef, slide) => {
				if($(slide.triggerEl) && $(slide.triggerEl).find('label').length > 0){
					return $(slide.triggerEl).find('label')[0];
				}
				else return "";
			},
		},
	});

    const media = window.matchMedia("(max-width: 991px)");
    mobileSupport(media);
    media.addListener(mobileSupport);
});

//popup
$.fn.openPopup = function () {
    const elem = $(this);
    if (elem.length > 0) {
        const opened_popup = $(".popup").filter(".show");

        if (opened_popup.length) 
            opened_popup.closePopup();
        
        elem.addClass("show");
        setTimeout(() => elem.addClass("animate"), 1);
        elem.trigger("openPopup");
        elem
            .off("click.popup")
            .on("click.popup", function (e) {
                if ($(e.target).hasClass("popup")) 
                    elem.closePopup();
                }
            );
    }
};
$.fn.closePopup = function () {
    const elem = $(this);
    if (elem.length > 0) {
        elem.removeClass("animate");
        setTimeout(() => elem.removeClass("show"), 400);
        elem.trigger("closePopup");
    }
};

$.is_mobile = false;
const mobileSupport = (media) => {
    if (media.matches) {
        $.is_mobile = true;
        $(document).trigger("mobile_on");
    } else {
        $.is_mobile = false;

        $(document).trigger("mobile_off");
    }
};